import { EAnalyticsFlagCategory } from "../types/analytics";

// NOTE: NSAI-5967 — Security Analytics value for a flagged message saved with
// no flag category. The server returns it as a Category Distribution key and
// accepts it as a Messages `status` filter value; both clients label it
// "Unsafe" (the `analytics:unsafe` key). It is not a stored category.
export const UNSAFE_FLAG_STATUS = "unsafe";

// NOTE: NSAI-3159 — every Messages `status` value a flagged message can match:
// the uncategorized "unsafe" bucket first, then the stored categories in enum
// order. Together they cover `flagged = true`, which is what the "All flagged"
// Status option selects. Listing the enum keeps a new category from being left
// out silently.
export const FLAGGED_MESSAGE_STATUSES: readonly string[] = [
  UNSAFE_FLAG_STATUS,
  ...Object.values(EAnalyticsFlagCategory),
];

// NOTE: NSAI-3159 — option id of the "All flagged" umbrella in the Status
// filter. Never sent to the server and never stored in the selection: the
// option expands to FLAGGED_MESSAGE_STATUSES (see `filters/multi-select.ts`).
export const ALL_FLAGGED_STATUS_OPTION_VALUE = "all_flagged";
